import { SentimentDistribution, SentimentType } from './model'

export const roundDistributionTo100 = (distribution: SentimentDistribution): SentimentDistribution => {
  const entries = Object.entries(distribution) as [SentimentType, number][]

  const floored = entries.map(([key, value]) => ({
    key,
    value: Math.floor(value),
    remainder: value - Math.floor(value),
  }))

  let total = floored.reduce((sum, item) => sum + item.value, 0)
  const missing = 100 - total

  floored.sort((a, b) => b.remainder - a.remainder)
  if (missing !== 0 && missing !== 100) {
    for (let i = 0; i < missing; i++) {
      floored[i].value += 1
    }
  }

  const rounded: SentimentDistribution = {
    positive: 0,
    neutral: 0,
    negative: 0,
  }

  for (const { key, value } of floored) {
    rounded[key] = value
  }

  return rounded
}
